const subscribers = {}

export const subscribe = (eventName, callback) => {
  subscribers[eventName] = callback
}

export const publish = async (eventName, payload) => {
  if (!subscribers[eventName]) return
  return await subscribers[eventName](payload)
}
